const internalReportActions = {
  FETCH_RESTAURANTS_LIST_START: 'FETCH_RESTAURANTS_LIST_START',
  FETCH_RESTAURANTS_LIST_SUCCESS: 'FETCH_RESTAURANTS_LIST_SUCCESS',
  FETCH_RESTAURANTS_LIST_FAILURE: 'FETCH_RESTAURANTS_LIST_FAILURE',

  fetchRestaurantsListStart: () => ({
    type: internalReportActions.FETCH_RESTAURANTS_LIST_START,
  }),
  fetchRestaurantsListSuccess: (restaurants) => ({
    type: internalReportActions.FETCH_RESTAURANTS_LIST_SUCCESS,
    payload: restaurants,
  }),
  fetchRestaurantsListFailure: (error) => ({
    type: internalReportActions.FETCH_RESTAURANTS_LIST_FAILURE,
    payload: error,
  }),
};

export default internalReportActions;
